module.exports = __webpack_public_path__ + "img/jacksonville-health-logo.c2a885e6.jpg";